import React, { useState, useCallback } from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, Valuat } from 'xland-ui';
import { useSelector } from 'react-redux';
import PopupInvite from './PopupInvite';

export const IM_FOUNDER = 'imFounder';
export const INVITE_FOUNDER = 'inviteFounder';
export const REQUEST_DEMO = 'requestDemo';

const FEATURES = [
  { id: IM_FOUNDER, action: 'openPopup' },
  { id: INVITE_FOUNDER, action: 'openPopup' },
  { id: REQUEST_DEMO, action: 'requestDemo' },
];

function EmptyPreHome() {
  const literals = useSelector(state => state.i18n.literals.prehome);
  const [selectedFeature, setSelectedFeature] = useState(null);

  const handleRequestDemo = useCallback((e) => {
    e?.preventDefault();
    e?.stopPropagation();
    window.zE?.('messenger', 'open');
  }, []);

  const handleAction = useCallback((action, featureId, e) => {
    const actions = {
      openPopup: () => setSelectedFeature(featureId),
      requestDemo: () => handleRequestDemo(e),
    };
    actions[action]?.();
  }, [handleRequestDemo]);

  const renderFeatureCard = useCallback(({ id, action }) => (
    <div
      key={id}
      className='box box-padding'
      onClick={e => handleAction(action, id, e)}
      role='button'
      tabIndex={0}
    >
      <h6 className='fw-b'>{literals[id]}</h6>
      <span>{literals[`${id}Description`]}</span>
    </div>
  ), [literals, handleAction]);

  const renderFeatureAction = useCallback(({ id, action }) => (
    <li key={id} onClick={(e) => handleAction(action, id, e)} role='button' tabIndex={0}>
      <div className='d-flex align-items-center'>
        <span>{literals[id]}</span>
      </div>
      <ArrowRight />
    </li>
  ), [literals, handleAction]);

  return (
    <>
      <Card className='mb-sp p-5'>
        <div className='setup-captable'>
          <div className='setup-captable--message'>
            <h3 className='fw-b'>{literals.setupCaptable}</h3>
            <div className='valuat-logo'><Valuat /></div>
            <div>{literals.chooseOption}</div>
          </div>
          <ul className='setup-captable--actions'>
            {FEATURES.map(renderFeatureAction)}
          </ul>
        </div>
      </Card>

      <div className='captable-features'>
        {FEATURES.map(renderFeatureCard)}
      </div>

      {selectedFeature && (
        <PopupInvite type={selectedFeature} onClose={() => setSelectedFeature(null)} />
      )}
    </>
  );
}

export default EmptyPreHome;
